export default __webpack_public_path__ + "static/media/404.4dd7b0a9.png";